var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoicePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon_06"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_06",
    "data-name": "Icon 06",
    clipPath: "url(#clip-Icon_06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(14 53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(-14 -53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(2.284 2.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M864.524,968.13a10.216,10.216,0,1,0,10.216,10.216,10.216,10.216,0,0,0-10.216-10.216m0,18.82a8.6,8.6,0,1,1,8.6-8.6,8.6,8.6,0,0,1-8.6,8.6",
    transform: "translate(-854.308 -968.13)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(5.56 5.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M876.725,997.485a6.94,6.94,0,1,1,6.94-6.94,6.948,6.948,0,0,1-6.94,6.94m0-13.225a6.285,6.285,0,1,0,6.285,6.285,6.292,6.292,0,0,0-6.285-6.285",
    transform: "translate(-869.785 -983.605)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M856.016,982.337a12.5,12.5,0,1,1,12.5-12.5A12.514,12.514,0,0,1,856.016,982.337Zm0-24.365a11.865,11.865,0,1,0,11.865,11.865A11.878,11.878,0,0,0,856.016,957.972Z",
    transform: "translate(-843.517 -957.337)",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M575.37,117.965h-1.351a2.662,2.662,0,0,0-1.066-1.862h2.417a.265.265,0,1,0,0-.531h-5.626a.265.265,0,1,0,0,.531h1.611a2.149,2.149,0,0,1,2.13,1.862h-3.741a.266.266,0,1,0,0,.531h3.741a2.152,2.152,0,0,1-2.13,1.888h-1.609a.271.271,0,0,0-.266.274.275.275,0,0,0,.083.192l4.023,3.8a.265.265,0,0,0,.375-.01.271.271,0,0,0-.011-.38l-3.539-3.348h.941a2.686,2.686,0,0,0,2.667-2.42h1.351a.266.266,0,1,0,0-.531Z",
    transform: "translate(-559.478 -107.572)",
    fill: "#6c5b7b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicePurple);
export default __webpack_public_path__ + "static/media/invoice-purple.bb560d5dc9585e0d5aa7ebdc95c959f5.svg";
export { ForwardRef as ReactComponent };